module.exports = __webpack_public_path__ + "static/img/KY-HSJEng.b4702e3.png";


//////////////////
// WEBPACK FOOTER
// ./static/bg/KY-HSJEng.png
// module id = 2e2x
// module chunks = 1